import React, { useMemo } from 'react'
import Card from '../../../../components/Card'
import IconButton from '../../../../components/IconButton'
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import {
    Media,
    MediaCategory,
    MediaWithCategories,
} from '../../../../types/Media'
import cx from 'classnames'
import styles from './MediaCard.module.scss'
import Image from '../../../../components/Image'
import Text from '../../../../components/Text'
import EditMediaModal from '../EditMediaModal/EditMediaModal'
import { openModal } from '../../../../services/ModalService'
import DeleteMediaModal from '../DeleteMediaModal/DeleteMediaModal'
import { useTranslation } from 'react-i18next'

const MediaCard: React.FC<{
    media: MediaWithCategories
    onEdit: (media: Media) => void
    onDelete: (media: Media) => void
    categories: MediaCategory[]
}> = ({ media, onEdit, onDelete, categories }) => {
    const { t } = useTranslation(['settings'])

    const openEditModal = (mediaElement: MediaWithCategories) => {
        const content: JSX.Element = (
            <EditMediaModal
                media={mediaElement}
                onSubmit={() => onEdit(mediaElement)}
            />
        )
        openModal({ heading: t('media.edit_modal.heading'), content: content })
    }

    const openDeleteModal = (mediaElement: Media) => {
        const content: JSX.Element = (
            <DeleteMediaModal
                media={mediaElement}
                onSubmit={() => onDelete(media)}
            />
        )
        openModal({
            heading: t('media.delete_modal.heading'),
            content: content,
        })
    }

    const mediaCategories = useMemo(() => {
        return categories
            .filter((c) => {
                const c_id = typeof c.id === 'string' ? parseInt(c.id) : c.id
                return media.media_category_ids.includes(c_id)
            })
            .map((c) => {
                c.name =
                    c.name.length > 8 ? c.name.substring(0, 8) + '...' : c.name
                return c
            })
    }, [categories, media.media_category_ids])

    return (
        <Card classes={cx(styles['card-wrapper'])}>
            <div className={cx(styles['card-button-wrapper'])}>
                <IconButton
                    icon={faEdit}
                    color={'#2f2f2f'}
                    onClick={() => openEditModal(media)}
                />
                <IconButton
                    icon={faTrashAlt}
                    color={'#2f2f2f'}
                    onClick={() => openDeleteModal(media)}
                />
            </div>
            <div className={cx(styles['card-inner-wrapper'])}>
                <div className={cx(styles['media-wrapper'])}>
                    <Image
                        src={media.path}
                        alt={media.name}
                        height={150}
                        width={150}
                    />
                    <Text>{media.name}</Text>
                    <div className={cx(styles['selected-categories'])}>
                        {mediaCategories.map((c) => {
                            return (
                                <div
                                    key={c.id}
                                    className={cx(
                                        styles['selected-categories-elements']
                                    )}
                                >
                                    <span>{c.name}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default MediaCard
